import { Module } from "@apis/index";
import { RootState } from "@store/index";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import BannerTable from "./Table";
import Header from "@commons/header";
import Tab from "@components/tabs";

const BannerList = () => {
  const { data: modules } = useSelector((state: RootState) => state.modules);
  const { data: user } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    Module.list({ state: "modules", params: { isActive: true } });
  }, []);
  const items = [
    {
      label: "Home",
      component: BannerTable,
      props: { isHome: true },
    },
    ...modules.map((module) => ({
      label: module.name,
      component: BannerTable,
      props: { moduleId: module.id },
    })),
  ];
  return (
    <>
      <Header title="All Banners" />
      {user.role === "store" ? (
        <BannerTable />
      ) : (
        <Tab items={items} fitContent paramKey="module" />
      )}
    </>
  );
};

export default BannerList;
